import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { ProjectContext } from './context/ProjectContext';
const PrivateRoutes = () => {
  const { token, setToken } = useContext(ProjectContext);

  return token ? <Outlet /> : <Navigate to='/' />;
};
export default PrivateRoutes;
